<template>
<v-app class="main">
  <v-app-bar 
  app
  absolute 
  flat
  height="80"
  class="main"
  > 
    <a href="/" style="text-decoration: none; display: inline-flex;" :class="$vuetify.breakpoint.smAndDown ? '' : 'ml-10 mt-2'">
      <v-img  
        class="img"
        src="@/assets/icon.svg" 
        contain
        alt="Logo"  
        width="80"/>
        <h2 class="info--text ml-2 mt-5" v-if="$vuetify.breakpoint.width > 700">Waste <span class="primary--text">Dash</span></h2>
    </a> 
    <div v-if="!$vuetify.breakpoint.smAndDown" class="links ml-12">
      <router-link to="/" :class="this.$router.currentRoute.fullPath == '/' ? 'ml-12 primary--text' : 'ml-12 info--text'" style="text-decoration: none;">Home</router-link>
      <router-link to="/about" :class="this.$router.currentRoute.fullPath == '/about' ? 'ml-12 primary--text' : 'ml-12 info--text'" style="text-decoration: none;">About Us</router-link>
      <router-link to="/help" :class="this.$router.currentRoute.fullPath == '/help' ? 'ml-12 primary--text' : 'ml-12 info--text'" style="text-decoration: none;">FAQs</router-link>
    </div>

    <v-spacer></v-spacer>

    <div class="links">
      <button
        class="b1 links mx-2" 
        @click="redirectLogin()"
        style="font-size: 16px; color: white; background-color: #EF5350; height: 50px; border-radius: 20px; width: 140px;"
        >
          Sign Up / Login
      </button>

       <button

        class="b2 links mr-2" 
        @click="redirect()"
        style="font-size: 16px; color: white; background-color: #EF5350; height: 50px; border-radius: 20px; width: 100px;"
        >
          Sign Up
      </button>

      <button
        class="b3 links" 
        @click="redirectLogin()"
        style="font-size: 16px; color: white; background-color: #EF5350; height: 50px; border-radius: 20px; width: 100px;"
        >
          Login
      </button>
    </div>
  </v-app-bar>

  <v-main class="main">
    <router-view></router-view>
  </v-main>

  <v-footer 
    app 
    absolute 
    padless 
    >
    <v-container style="background-image: linear-gradient(to right, white, #E57373);" fluid>
      <v-row class="px-4 pb-4 footer">
        <v-row :style="$vuetify.breakpoint.smAndDown ? 'display: block;' : ''">
          <v-col class="info--text mt-12" md="4">
            <div :style="$vuetify.breakpoint.smAndDown ? 'display: inline-flex;' : ''">
              <a href="/" style="text-decoration: none;"> <v-img contain width="86" src="@/assets/icon.svg"/> </a> 
              <a v-if="$vuetify.breakpoint.smAndDown" class="ml-12 mt-5" href="https://www.facebook.com/wrappwaste" target="_blank" style="text-decoration: none;"><v-icon class="primary--text mr-4" large>mdi-facebook</v-icon></a>
              <a v-if="$vuetify.breakpoint.smAndDown" class="mt-5" href="https://www.instagram.com/dashwaste/" target="_blank" style="text-decoration: none;"><v-icon class="primary--text mr-4" large>mdi-instagram</v-icon></a>  
              <a v-if="$vuetify.breakpoint.smAndDown" class="mt-5" href="https://api.whatsapp.com/send?phone=27722459777" target="_blank" style="text-decoration: none;"><v-icon class="primary--text" large>mdi-whatsapp</v-icon></a> 
            </div>
            <br/>
            <p>Waste Dash makes waste removal  simple, <br v-if="!$vuetify.breakpoint.smAndDown"/> transparent, and dependable - since 2007.</p>
          </v-col>
          <v-col class="info--text mt-12">
            <h3 style="font-family: Avenir1;">Quick Links</h3><br/>
            <router-link class="info--text" style="text-decoration: none;" to="/about"> About us</router-link><br/>
            <a class="info--text" style="text-decoration: none;" href="/#testimonials"> Testimonials</a><br/>
            <router-link class="info--text" style="text-decoration: none;" to="/help"> FAQS</router-link><br/>
            <router-link class="info--text" style="text-decoration: none;" to="/driver"> Become a Service Provider</router-link><br/>
          </v-col>
          <v-col class="info--text mt-12">
            <h3 style="font-family: Avenir1;">Legal</h3><br/>
            <router-link class="info--text" style="text-decoration: none;" to="/tc"> Terms of Use</router-link><br/>
          </v-col>
          <v-col class="info--text mt-12" md="4">
            <h3 style="font-family: Avenir1;">Business Details</h3><br/>
            <p> Head Office: 36 Zinfandal Rd, Blackheath, Cape Town, South Africa
              <br/>Registration Number: 2007/008 563/07 <br/>
              VAT Number: 463 027 9224</p>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-divider class="primary"></v-divider>
            <br/>
            <v-row>
              <v-col v-if="!$vuetify.breakpoint.smAndDown">
              <a href="https://www.facebook.com/wrappwaste" target="_blank" style="text-decoration: none;"><v-icon class="primary--text mr-4" large>mdi-facebook</v-icon></a>
              <a href="https://www.instagram.com/dashwaste/" target="_blank" style="text-decoration: none;"><v-icon class="primary--text mr-4" large>mdi-instagram</v-icon></a>  
              <a href="https://api.whatsapp.com/send?phone=27722459777" target="_blank" style="text-decoration: none;"><v-icon class="primary--text" large>mdi-whatsapp</v-icon></a>  
            </v-col>
              <v-col md="2">
                <button
                  @click="redirect()"
                  style="font-size: 18px; color: black; height: 50px; border: 1px solid black; border-radius: 20px; width: 100%;"
                  >
                    Sign Up
              </button>
              </v-col>
              <v-col md="2">
                <button
                  @click="redirectLogin()"
                  style="font-size: 18px; color: black; height: 50px; border: 1px solid black; border-radius: 20px; width: 100%;"
                  >
                    Client Login
                </button>
              </v-col>     
            </v-row>
          </v-col>
        </v-row>
      </v-row>
    </v-container>
  </v-footer>
</v-app>
</template>

<script>


export default {

components: {

},
  name: 'App',
  methods: {
    redirect(){
      window.location.href = 'https://app.wastedash.com/signup';
    },
    redirectLogin(){
      window.location.href = 'https://app.wastedash.com/login';
    }
  },
  mounted(){
    scrollTo(0, 0);
  }
}

</script>

<style scoped>
.b1{
  display: none;
}
.links{
  font-family: Avenir2;
  font-style: normal;
  font-size: 16px;
  line-height: 20px;
  }
  .footer{
  font-family: Avenir3;
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
}

@media screen and (max-width: 450px){
  .img{
    max-width: 125px;
  }
  .b1{
    display: block;
  }
  .b2, .b3{
    display: none;
  }

}
</style>
